import { css, jsx } from '@emotion/core';
import { List, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';

import { colors } from '@/styles';
import request from '@/utils/axios';

const style = {
  meta: css`
    .ant-list-item-meta-title {
      font-weight: bolder;
      margin-bottom: 0;
      color: ${colors.primaryBlue};
    }
  `,
};

function Sources(props) {
  const { size } = props;
  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);

  useEffect(() => {
    (async function mounted() {
      try {
        const response = await request({ url: 'statesnapshot/sourcelist' });
        const { data } = response;
        setSources(data.Sources);
        setLoading(false);
      } catch (error) {
        setSources([]);
        setLoading(false);
      }
    })();
  }, []);

  return (
    <List
      itemLayout="vertical"
      size={size || 'middle'}
      dataSource={sources}
      renderItem={source => (
        <List.Item key={source.Category}>
          <Skeleton loading={loading} active>
            <List.Item.Meta
              css={style.meta}
              title={source.Category}
              // description={<span><b>Report Year</b>: {source.ReportYear}</span>}
            />
            {source.Description}
          </Skeleton>
        </List.Item>
      )}
    />
  );
}

export default Sources;
